import { render, staticRenderFns } from "./WhyWe.vue?vue&type=template&id=bb95f3be&scoped=true&"
import script from "./WhyWe.vue?vue&type=script&lang=js&"
export * from "./WhyWe.vue?vue&type=script&lang=js&"
import style0 from "./WhyWe.vue?vue&type=style&index=0&id=bb95f3be&prod&lang=scss&"
import style1 from "./WhyWe.vue?vue&type=style&index=1&id=bb95f3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb95f3be",
  null
  
)

export default component.exports